import React from "react";
import { Thumbnail } from "@culturehq/components";

const RecognitionTypeImage = ({ recognitionType, imageKey, ...props }) => (
  <Thumbnail square image={recognitionType.image[imageKey]} {...props} />
);

export const RecognitionTypeThumbnailImage = props => (
  <RecognitionTypeImage {...props} imageKey="thumbUrl" />
);

export const RecognitionTypeMediumImage = props => (
  <RecognitionTypeImage {...props} imageKey="thumbUrl" size="medium" />
);

export const RecognitionTypeLargeImage = props => (
  <RecognitionTypeImage {...props} imageKey="mediumUrl" size="large" />
);
